import styled from "styled-components";

const ContatoDetails = styled.div`
  width: 100%;

  margin: 70px 0px 100px 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  @media (max-width: 700px) {
    margin: 20px 0px 40px 0px;
  }

  .img_contact {
    height: 320px;

    @media (max-width: 700px) {
      width: 100%;
      height: 100%;
    }
  }

  .floatbutton {
    position: fixed;
    bottom: 7%;
    right: 30px;
    z-index: 999;

    background-color: #25d366;
    color: white;

    width: 50px;
    height: 50px;
    border-radius: 50%;

    font-size: 1.5rem;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export default ContatoDetails;
